import request from '@/utils/request';

export const ADMIN_AUTH_IPS = 'ADMIN_AUTH_IPS';

export const fetchAdminAuthIps =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: '/v1/admin/auth_ips',
      query
    });
    dispatch({
      payload: response,
      type: ADMIN_AUTH_IPS
    });
  };
